import { render, staticRenderFns } from "./PosBadgeTest.vue?vue&type=template&id=0220e7c9"
import script from "./PosBadgeTest.vue?vue&type=script&lang=js"
export * from "./PosBadgeTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports